import { render, staticRenderFns } from "./jsfzSwiper.vue?vue&type=template&id=36f9f61d&scoped=true&"
import script from "./jsfzSwiper.vue?vue&type=script&lang=js&"
export * from "./jsfzSwiper.vue?vue&type=script&lang=js&"
import style0 from "./jsfzSwiper.vue?vue&type=style&index=0&id=36f9f61d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f9f61d",
  null
  
)

export default component.exports